import request from '../../libs/request';

export default {
  getUsersIP: () => {
    return request('/', 'https://api.ipify.org').get({
      queryParams: { format: 'json' },
    });
  },
};
